import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";

export async function avatarShow(
    owner_id: string,
    query?: QueryType
) {

    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/console/avatar/${owner_id}/show${queryString}`
    );
}

export async function avatarCreate(
    console_id: string,
    image_id: string
) {
    return await clientAxios.post(
        `admin/console/avatar/${console_id}/create`,
        { image_id }
    );
}

export async function avatarUpdate(
    console_id: string,
    image_id: string
) {
    return await clientAxios.put(
        `admin/console/avatar/${console_id}/update`,
        { image_id }
    );
}

export async function avatarDelete(
    console_id: string,
) {
    return await clientAxios.del(
        `admin/console/avatar/${console_id}/delete`,
    );
}
